export default {
  // functions return fixtures

  setHeader: (header: string, value: any) => {
    return `Go ahead Ninja. I don't need this crap -> ${header}: ${value}`;
  },

  dummy: async () => require('./dummy.json'),
  getAssessmentsList: async () => require(`./assessments/list.json`),
  getAssessmentResult: async (assessmentID: number, userID: number) => {
    // this should technically translate to and endpoint living on
    // https://[BASE_URL]/api/v1/assessments/:id/users/:id
    // theoretically that is :)
    let query = 'john';

    if (userID === 2) {
      query = 'mom';
    } else if (userID === 3) {
      query = 'jane';
    } else if (userID === 4) {
      query = 'june';
    } else if (userID === 5) {
      query = 'dad';
    }

    return require(`./assessments/${assessmentID}/results/${query}.json`);
  },
  getUserProfile: async (userID: number) => require(`./users/${userID}.json`),
  getSystemGroups: async () => require('./groups/list.json'),
  getStudentData: async (id: number) => require(`./students/${id}/courses/index.json`),
  getStudentLessonStats: async (studentID: number, courseID: number, lessonID: number) => {
    return require(`./students/${studentID}/courses/2/lessons/3.json`);
  },
  // demo for search filters (institution)
  getInstitutionAssessments: async () => require(`./institutions/list.json`),
  getInstitutionAssessmentQuestionGroups: async (assessmentID: number) => require(`./institutions/assessments/${assessmentID}/questiongroups/results.json`),
  getStudentsFilteredByGroups: async (assessmentID: number, groupID: number) => require(`./institutions/assessments/${assessmentID}/filteredstudents/${groupID}/list.json`),

  // onboarding
  getUserOnboardingQuestions: async (userType) => require(`./onboarding/${userType}/questions.json`),
  getPlexPathwaysData: async () => require(`./onboarding/plexing/pathways.json`),

  // behaviours
  getAssessmentsBehaviours: async () => require(`./behaviours/behaviours.json`),
  getTopBottomBehaviours: async () =>  require(`./behaviours/topbottombehaviours.json`),

  // packages
  getPackages: async () => require(`./packages/packages.json`),

  // burton viz
  getPerceptionsList: async () => require('./perceptionslist/perceptionslist.json'),
  getPerceptionsOverTime: async (perceptionID) => require(`./institutions/assessmentsperceptions/${perceptionID}/results.json`),
  simulateSignUp: () => {
    const random = Math.floor((Math.random() * 10));
    if(random % 2 === 0) {
      return true;
    }else {return false}
  }
};



// WEBPACK FOOTER //
// ./src/services/API/fixtures/index.ts